module.exports = __webpack_public_path__ + "static/img/memberportal-step1.dbfcdf9f.svg";